import React, { useState, useEffect } from "react";
import FadeInSection from "./FadeInSection"; // Import animation wrapper
import "./DecisionAgentOptimization.css"; // Import the CSS file

const DecisionAgentOptimization = () => {
  const [dlAccuracy, setDlAccuracy] = useState("Loading...");
  const [numTrainingExamples, setNumTrainingExamples] = useState("Loading...");

  // Fetch accuracy and training examples from the backend
  useEffect(() => {
    const fetchDetails = async () => {
      try {
        const response = await fetch("https://agentsserver.modlee.ai:5000/moderation_details");
        if (!response.ok) {
          throw new Error("Failed to fetch details from the server");
        }
        const data = await response.json();
        setDlAccuracy(`${data.accuracy}%`);
        setNumTrainingExamples(data.num_training_examples);
      } catch (error) {
        console.error("Error fetching deep learning details:", error);
        setDlAccuracy("Error");
        setNumTrainingExamples("Error");
      }
    };

    fetchDetails();
  }, []);

  return (
    <FadeInSection className="decision-agent-optimization-container">
      <h2 className="decision-agent-optimization-title">
        Our Approach to Niche Agents
      </h2>
      <p>
        A proven blueprint to solve any task with AI agents—quickly, easily, and at scale.
      </p>

      <div className="decision-agent-optimization-grid">
        {/* Column 1 - LLM-Based Start */}
        <div className="decision-agent-optimization-item">
          <h3 className="decision-agent-optimization-subtitle">Define Your LLM-Based Agent</h3>
          <ul className="decision-agent-optimization-text">
            <li>
              Combine foundational agents with top LLMs for rapid solutions.
            </li>
            <li>
              LLMs are costly at scale, making them inefficient for frequent tasks.
            </li>
          </ul>
        </div>

        {/* Column 2 - Scaling with Distillation */}
        <div className="decision-agent-optimization-item">
          <h3 className="decision-agent-optimization-subtitle">Optimize with Knowledge Distillation</h3>
          <ul className="decision-agent-optimization-text">
            <li>
              With our package, enable automated distillation with just a few lines of code.
            </li>
            <li>
              Replace LLM-tasks with a smaller model that maintains LLM-level accuracy at lower cost.
            </li>
          </ul>
        </div>

      </div>
      <h4 className="decision-agent-optimization-results">
        In just <strong>{numTrainingExamples} reviews</strong>, our approach trained a model that achieves <strong>{dlAccuracy} of LLM accuracy</strong> while being <strong>10,000x smaller</strong> in size for this demo.
      </h4>

    </FadeInSection>
  );
};

export default DecisionAgentOptimization;
